import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import axios from "../lib/axios";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import "./operation.css";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPermissions } from "../redux/permissionsSlice";
import fetchStatusCounts from "../GlobalFunction/Counts";
import { toast } from "react-toastify";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Operations = () => {
  const names = [
    "House Keeping Type",
    "Machine Master",
    "House Keeping ",
    "Maintenance Type",
    "Vehicle Master",
  ];
  const location = useLocation();
  const navigate = useNavigate();
  const [counts, setCounts] = useState([]);


  const parentId = 43;

  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId])


  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  const matchHKType = matchedItem('House Keeping Type Master');
  const matchShift = matchedItem('Shift Master');

  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      (permission) => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  const [TotalCount, setTotalCount] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [inactiveCount, setInactiveCount] = useState(0);

  const fetchHkTypeData = async () => {
    try {
      const response = await axios.post("MstHkType/getAllMstHkTypeDashBoard", {
        start: 0,
        PageSize: 0,
        SearchText: "",
      });

      if (response.data.Status === 0) {
        const hkTypes = response.data.Data;

        setTotalCount(hkTypes.length);

        setActiveCount(
          hkTypes.filter((item) => item.Status === "Active").length
        );
        setInactiveCount(
          hkTypes.filter((item) => item.Status === "Inactive").length
        );
      }
    } catch (error) {
      toast.error("Error fetching housekeepingtype data:", error);
    }
  };

  useEffect(() => {
    fetchHkTypeData();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {/* {hasModulePermission("House Keeping") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                permissions={permissions}
                title="House Keeping"
              />
            )} */}

            {/* {hasModulePermission("Machine Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                permissions={permissions}
                title="Machine Master"
              />
            )} */}
            {/* {hasModulePermission("Maintenance Type") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                permissions={permissions}
                title="Maintenance Type"
              />
            )} */}

            {/* {hasModulePermission("Maintenance Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                permissions={permissions}
                title="Maintenance Master"
              />
            )} */}
            {/* {hasModulePermission("Vehicle Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link="#"
                permissions={permissions}
                title="Vehicle Master"
              />
            )} */}

            {hasModulePermission("Shift Master") && matchShift && (
              <BoxWithIcon
                totalCount={matchShift.TotalCount}
                activeCount={matchShift.ActiveCount}
                inactiveCount={matchShift.InactiveCount}
                link={{ pathname: '/masters/shift-table' }}
                permissions={permissions}
                title="Shift Master"
              />
            )}

            {hasModulePermission("Work Type") && matchHKType && (
              <BoxWithIcon
                totalCount={matchHKType.TotalCount}
                activeCount={matchHKType.ActiveCount}
                inactiveCount={matchHKType.InactiveCount}
                title="Work Type"
                link={{ pathname: "/hk-typetable" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Worker Type Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Worker Type Master"
                link={{ pathname: "/worker-type-table" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Work Station") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Work Station"
                link={{ pathname: "/workstationtable" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Property Wise Station") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Property Wise Station"
                link={{ pathname: "/prop-wisestation" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Work Area/Sub Station") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Work Area/Sub Station"
                link={{ pathname: "/workareatable" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Sub Station Allocation") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Sub Station Allocation"
                link={{ pathname: "/substntable" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Worker Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Worker Master"
                link={{ pathname: "/hk-worker-table" }}
                permissions={permissions}
              />
            )}
            {hasModulePermission("Task/Todo Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Task/Todo Master"
                link={{ pathname: "/hktasktable" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Yojana Master") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Yojana Master"
                link={{ pathname: "/yojana-master" }}
                permissions={permissions}

              />
            )}

            {hasModulePermission("Yojana Allocate to SubStation") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Yojana Allocate to SubStation"
                link={{ pathname: "/yojana-alocationtable" }}
                permissions={permissions}
              />
            )}
            {hasModulePermission("Yojana Allocate to SubStation") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={10}
                title="Weekly Wise Yojana Allocation"
                link={{ pathname: "/weekly-yojana" }}
                permissions={permissions}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Operations;
